import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';
import { localStorageKeys } from '../Models/configurations';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  public themeLogoVariable: string;
  public currencyType:string;

  constructor(
    @Inject(DOCUMENT) private document:Document,
    private readonly secureStorageService: SecureStorageService,
  ) {
    this.themeLogoVariable = 'assets/images/logo.png';
  }

  themeInitializer(_clientName) {
      this.document.getElementById('appStyle').setAttribute('href', 'assets/css/style.checkin.css');
      this.themeLogoVariable = 'assets/images/logo.png';
      this.currencyType='GBP';
    
    this.secureStorageService.setKeyData(localStorageKeys.logo, this.themeLogoVariable);
    this.secureStorageService.setKeyData(localStorageKeys.currencyType, this.currencyType);
  }
}
